import type { AppConfig } from 'nuxt/schema';
import { useAppConfig } from '#app/config';
import { mergeUi } from '#layers/ui/utils/merge-ui';

export function useMergedTheme<ComponentKey extends keyof AppConfig['ui'], ComponentTheme extends Record<string, any>>(namedTheme: { [K in ComponentKey]: ComponentTheme }) {
	const appConfig = useAppConfig();
	const componentKey = Object.keys(namedTheme)[0] as ComponentKey;
	return mergeUi(
		namedTheme[componentKey],
		appConfig.ui[componentKey] as unknown as ComponentTheme,
	) as ComponentTheme;
}
